<div *ngIf="this.incomeTaxEntity.aangifte?.persoonsgebondenAftrek?.pgaScholingsuitgaven &&
            Object.keys(this.incomeTaxEntity.aangifte?.persoonsgebondenAftrek?.pgaScholingsuitgaven || {}).length > 0">
  <form [formGroup]="specScholingFormGroup">
    <div class="row">
      <div formGroupName="specificatieScholing">
        <div formGroupName="opbouw">
          <div>
            <div class="row">
              <div class="col col-1">
                  <p><b>Aftrekbare scholingskosten</b></p>
              </div>
              <div class="col-2">
                <snelstart-ui-number-form-control
                  formControlName="aftrekbaarAangever"
                  id="aftrekbaarAangever"
                  class="custom-input-150"
                  [decimals]="0"
                  align="right"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
                <div class="col-2"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
